/* ============================================================
   OPALINE — Animations & Scroll Reveal
   Code original — aucune copie de thème tiers
   ============================================================ */

(function () {
  'use strict';

  /* ── Scroll Reveal ── */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
    );

    /* Une carte posee dans un carrousel horizontal est rognee par sa
       piste : son intersection avec la fenetre reste nulle tant qu'on ne
       l'a pas fait defiler, et le seuil de 10 % n'est jamais atteint.
       Elle restait donc a l'opacite zero — le visiteur faisait glisser le
       carrousel et trouvait du vide. On observe la piste a sa place, et
       toutes ses cartes apparaissent avec elle. */
    function pisteHorizontale(el) {
      let n = el.parentElement;
      while (n && n !== document.body) {
        const ox = getComputedStyle(n).overflowX;
        if ((ox === 'auto' || ox === 'scroll') && n.scrollWidth > n.clientWidth + 1) return n;
        n = n.parentElement;
      }
      return null;
    }

    const pistes = new Map();
    document.querySelectorAll('.lf-reveal').forEach((el) => {
      const piste = pisteHorizontale(el);
      if (!piste) {
        observer.observe(el);
        return;
      }
      if (!pistes.has(piste)) pistes.set(piste, []);
      pistes.get(piste).push(el);
    });

    if (pistes.size) {
      const surPiste = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            (pistes.get(entry.target) || []).forEach((el) => el.classList.add('is-visible'));
            surPiste.unobserve(entry.target);
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
      );
      pistes.forEach((_, piste) => surPiste.observe(piste));
    }
  }

  /* La parallaxe [data-lf-parallax] est désormais pilotée par
     lf-motion.js, qui partage une seule boucle rAF pour tous les
     effets liés au scroll. */

  /* ── Image hover zoom (pour les cartes produit) ── */
  function initImageHover() {
    document.querySelectorAll('.lf-card__image-wrap').forEach((wrap) => {
      const img = wrap.querySelector('img');
      if (!img) return;

      wrap.addEventListener('mouseenter', () => {
        img.style.transform = 'scale(1.04)';
      });
      wrap.addEventListener('mouseleave', () => {
        img.style.transform = 'scale(1)';
      });
    });
  }

  /* ── Compteur animé (chiffres) ── */
  function animateCounter(el) {
    const target   = parseInt(el.dataset.lfCount, 10);
    const duration = parseInt(el.dataset.lfCountDuration, 10) || 1500;
    const start    = performance.now();

    function tick(now) {
      const elapsed  = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // easeOutExpo
      const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      el.textContent = Math.round(eased * target).toLocaleString();
      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function initCounters() {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    document.querySelectorAll('[data-lf-count]').forEach((el) => observer.observe(el));
  }

  /* ── Marquee (scrolling text) ── */
  function initMarquee() {
    document.querySelectorAll('.lf-marquee__track').forEach((track) => {
      const clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.parentElement.appendChild(clone);
    });
  }

  /* ── Tabs ── */
  function initTabs() {
    document.querySelectorAll('[data-lf-tabs]').forEach((container) => {
      const tabs    = container.querySelectorAll('[data-lf-tab]');
      const panels  = container.querySelectorAll('[data-lf-panel]');

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.lfTab;

          tabs.forEach((t)   => t.setAttribute('aria-selected', 'false'));
          panels.forEach((p) => p.setAttribute('hidden', ''));

          tab.setAttribute('aria-selected', 'true');
          const panel = container.querySelector(`[data-lf-panel="${target}"]`);
          if (panel) panel.removeAttribute('hidden');
        });
      });
    });
  }

  /* ── Accordion ── */
  function initAccordion() {
    document.querySelectorAll('.lf-accordion__trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item    = trigger.closest('.lf-accordion__item');
        const content = item.querySelector('.lf-accordion__content');
        const open    = item.classList.contains('is-open');

        // close siblings
        const siblings = trigger.closest('.lf-accordion').querySelectorAll('.lf-accordion__item');
        siblings.forEach((s) => {
          s.classList.remove('is-open');
          const sc = s.querySelector('.lf-accordion__content');
          if (sc) sc.style.maxHeight = '0';
          s.querySelector('.lf-accordion__trigger')?.setAttribute('aria-expanded', 'false');
        });

        if (!open) {
          item.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── Back to top ── */
  function initBackToTop() {
    const btn = document.getElementById('lf-back-to-top');
    if (!btn) return;

    window.addEventListener('scroll', () => {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── Sticky header ── */
  function initStickyHeader() {
    const header = document.querySelector('.lf-header');
    if (!header) return;

    let lastY = 0;

    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const scrolled  = y > 80;
      const scrollingDown = y > lastY;

      header.classList.toggle('lf-header--scrolled', scrolled);
      header.classList.toggle('lf-header--hidden', scrolled && scrollingDown && y > 300);

      lastY = y;
    }, { passive: true });
  }

  /* ── Scrollbar width (pour éviter le saut lors des modals) ── */
  function setScrollbarWidth() {
    const w = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--lf-scrollbar-width', w + 'px');
  }

  /* ── Init ── */
  function init() {
    setScrollbarWidth();
    initScrollReveal();
    initImageHover();
    initCounters();
    initMarquee();
    initTabs();
    initAccordion();
    initBackToTop();
    initStickyHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Re-init sur navigation Shopify ── */
  document.addEventListener('shopify:section:load', init);
})();
